import React from 'react';
import {Button} from '@material-ui/core';
import './Music.css';

function MusicOne() {
  return (
    <div className="music">
      <a href="https://www.youtube.com/watch?v=p99i3PCNiIw" target="_blank" rel="noreferrer">
        <div className="music__card">
          <img
            src="https://bekaboy.com/wp-content/uploads/2020/12/Ikinyafu-VIDEO.jpg"
            alt="Ikinyafu by bruce melody"
            className="music__banner"
          />
          <div className="music__watch__button">
            <h2>
              Ikinyafu - Official Video. <br /> Bruce Melody ft Anyone
            </h2>
            <a href="https://www.youtube.com/watch?v=p99i3PCNiIw" target="_blank" rel="noreferrer">
              <Button variant="contained" color="primary">
                WATCH NOW
              </Button>
            </a>
          </div>
        </div>
      </a>
    </div>
  );
}

export default MusicOne;
